'use strict';

const saEmailValidator = [
  'patterns',

  function (patterns) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function ($scope, $element, $attr, ngModel) {
        var emailRegexp = new RegExp(patterns.email);

        ngModel.$validators.pattern = function (value) {
          return !ngModel.$isEmpty(value) && emailRegexp.test(value);
        };
      }
    };
  }
];

export default saEmailValidator;



// WEBPACK FOOTER //
// ./app/src/directives/email_validator.js